import { Action } from '@ngrx/store';
import { Leaderboard } from '../models/leaderboard.model';

export enum LeadsActionTypes {
  LEADS_QUERY = '[Leads] Query',
  LEADS_QUERY2 = '[Leads] Query2',
  LEADS_LOADED = '[Leads] Fetched',

  LEADS_ADDED = '[Leads] Added',
  LEADS_EDITED = '[Leads] Edited',
  LEADS_DELETED = '[Leads] Deleted',
  LEADS_SAVED = '[Leads] Saved',

  LEADS_ERROR = '[Leads] Error'
}

export class LeadsQuery implements Action {
  readonly type = LeadsActionTypes.LEADS_QUERY;
}

export class LeadsQuery2 implements Action {
  readonly type = LeadsActionTypes.LEADS_QUERY2;
}

export class LeadsLoaded implements Action {
  readonly type = LeadsActionTypes.LEADS_LOADED;

  constructor(public payload: { leads: Leaderboard[] }) {}
}

export class LeadsAdded implements Action {
  readonly type = LeadsActionTypes.LEADS_ADDED;

  constructor(public payload: { lead: Leaderboard }) {}
}

export class LeadsEdited implements Action {
  readonly type = LeadsActionTypes.LEADS_EDITED;

  constructor(public payload: { lead: Leaderboard }) {}
}

export class LeadsSaved implements Action {
  readonly type = LeadsActionTypes.LEADS_SAVED;

  constructor(public payload: {lead: Leaderboard}) {}
}

export class LeadsDeleted implements Action {
  readonly type = LeadsActionTypes.LEADS_DELETED;

  constructor(public payload: { lead: Leaderboard }) {}
}

export class LeadsError implements Action {
  readonly type = LeadsActionTypes.LEADS_ERROR;

  constructor(public payload: { error: any }) {}
}

export type LeadsActions =
  | LeadsQuery
  | LeadsQuery2
  | LeadsLoaded
  | LeadsAdded
  | LeadsEdited
  | LeadsSaved
  | LeadsDeleted
  | LeadsError;
